import useIsInappWebview from "hooks/useIsInappWebview";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import { Button } from "@mui/joy";
import { useNavigate } from "react-router-dom";
import { theme } from "../../styles/theme";

export default function PCLoginButton({
  render,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
}) {
  const isInappWebview = useIsInappWebview();
  const navigate = useNavigate();

  const user = useRecoilValue(userAtom);

  return (
    <Button
      size={"lg"}
      variant={"Plain"}
      color={"neutral"}
      sx={{
        backgroundColor: theme.vars.palette.Surface.Forward,
        color: theme.vars.palette.Content.Strong,
        "&:focus": {
          backgroundColor: theme.vars.palette.Surface.Forward,
          color: theme.vars.palette.Content.Strong,
        },
      }}
      onClick={() => {
      navigate("/pc/login");
    }}>
      {"디스턴싱 시작하기"}
    </Button>
  );
}
